export default "__VITE_ASSET__dqIx_Flo__"